import { ResultAPI } from 'app/requests/apiRequest';
import * as chatApi from 'app/requests/chats';

var music: HTMLAudioElement | null = null;

export const playAudio = (url: string) => {
  if (music) music.pause();
  music = new Audio(url);
  music.play();
}

export const speakText = async (text: string, lang = 'en') => {
  const data = await chatApi.speak({ text, lang }) as ResultAPI;
  playAudio("data:audio/wav;base64," + data.data);
}
